<template>
  <v-container
      fluid
  >
    <v-card class="pa-5" tile>
      <v-form
        autocomplete="off"
        @submit="function(e){saveItem();e.preventDefault()}"
      >

        <v-row class="mt-n5">
          <v-col cols="2" sm="2" class="px-0">
            {{ $t('Next appointment') }}
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('From') }}
            <date-picker-field
                v-model="search.from_next_appointment_date"
                :error-messages="errors.from_next_appointment_date"
                :label="undefined"
                clearable
                tabindex="10"
            >
            </date-picker-field>
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('To') }}
            <date-picker-field
                v-model="search.to_next_appointment_date"
                :error-messages="errors.to_next_appointment_date"
                :label="undefined"
                clearable
                tabindex="15"
            >
            </date-picker-field>
          </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Appointment location') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.appointment_location_ids"
                    :error-messages="errors.appointment_location_ids"
                    :items="appointment_locations"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="20"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
          <v-col cols="2" sm="2" class="px-0">
            {{ $t('Date of birth') }}
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('From') }}
            <date-picker-field
                v-model="search.from_birth_date"
                :error-messages="errors.from_birth_date"
                :label="undefined"
                clearable
                tabindex="30"
            >
            </date-picker-field>
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('To') }}
            <date-picker-field
                v-model="search.to_birth_date"
                :error-messages="errors.to_birth_date"
                :label="undefined"
                clearable
                tabindex="35"
            >
            </date-picker-field>
          </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Status') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.status_ids"
                    :error-messages="errors.status_ids"
                    :items="statuses"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="40"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Province') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.province_ids"
                    :error-messages="errors.province_ids"
                    :items="provinces"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="50"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Municipality') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.municipality_ids"
                    :error-messages="errors.municipality_ids"
                    :items="municipalities"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="60"
                />
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" sm="2" class="px-0">
                {{ $t('Action') }}
            </v-col>
            <v-col cols="2" sm="2" class="px-0">
                <v-btn @click="resetForm">{{ $t('Clear form') }}</v-btn>
                &nbsp;
                <v-btn @click="exportXls">{{ $t('Export XLS') }}</v-btn>
            </v-col>
        </v-row>

      </v-form>

    </v-card>
  </v-container>

</template>

<script>
import ApiService from '@/services/api.service'
import DatePickerField from '@/components/DatePickerField'
import {fetchMultipleLists2, fetchList} from '@/lib/helpers'

export default {
  components: {
    DatePickerField,
  },
  data: () => ({
    errors: {},
    search: {},
    appointment_locations: null,
    statuses: null,
    provinces: null,
    municipalities: null,
  }),
  watch: {
    '$i18n.locale': function () {
        this.fetchTranslatables()
    },
    'search.province_ids'() {
        fetchList(this, 'municipalities', '/municipalities/get-list', 'province_master_file_ids', this.search.province_ids)
    },
  },
  methods: {
    resetForm() {
      this.search = {
        from_next_appointment_date: null,
        to_next_appointment_date: null,
        appointment_location_ids: null,
        from_birth_date: null,
        to_birth_date: null,
        status_ids: null,
        province_ids: null,
        municipality_ids: null,
      }
    },
    getItem() {
      const item = this.search
      return item
    },
    exportXls() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')
     
      ApiService.download(`/exports/medical-checkup/xls`, { filter: this.search }).then(response => {
        this.openFile(response.data, response.filename)
      }).catch(errors => {
        this.errors = errors
        console.log(errors)
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    openFile(blob, filename) {
        const data = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = data;
        link.download=filename;
        link.click();
        setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    },    
    fetchTranslatables() {
        fetchMultipleLists2(this, {
            // These must be listed in created() as well
            statuses: 'module_status',
        }, '/master-files/get-multiple-lists', 'master_file_type_tags')
    },
  },
  created() {
    this.resetForm();
    this.$store.dispatch('session/title', 'Reports - Medical check-up program')
    fetchMultipleLists2(this, {
        // Non-translatable
        appointment_locations: 'appointments_where',
        provinces: 'province',

        // Translatable; must be listed in fetchTranslatables() as well
        statuses: 'module_status',
    }, '/master-files/get-multiple-lists', 'master_file_type_tags')

    fetchList(this, 'municipalities', '/municipalities/get-list', null, null);
  },
}
</script>

<style scoped>

</style>
